import { Appointment } from "@elixir/types";
import { updateAppointment } from "../../utils/bridges/methods";
import { logAndGetErrorResponse } from "../error";
import { ControllerReturnType } from "../types";
import {
  AptActivityType,
  trackAppointmentActivity,
} from "./appointment-activity";

export default async function submitFieldValue({
  appointment,
  field,
  value
}: {
  appointment: Pick<Appointment, "aid" | "apt_fields">;
  field: keyof Appointment;
  value?: string;
}): Promise<ControllerReturnType> {
  try {
    const { aid } = appointment;
    await updateAppointment({
      data: {
        [field]: value ?? null,
      },
      aid,
    });

    trackAppointmentActivity({
      aid,
      activity: AptActivityType.SUBMIT_FIELD,
    });
    return { success: true };
  } catch (e) {
    return logAndGetErrorResponse(e);
  }
}
